import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { MainPipes } from '../../pipes/main-pipes-module';

import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';

import { DossierDetailModule } from '../components/dossierDetail.module';

import { DossierHeaderModule } from '../components/dossierHeader.module';
import { DocumentFileModule } from '../../documents/documentFile/documentFile.module';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { awardsListComponent } from './awardsList.component';
import { TableModule } from 'primeng-lts/table';
import { DialogService, DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { awardEditionComponent } from './awardEdition.component';
import { AwardDeclaraNoAdjComponent } from './awardDeclaraNoAdj.component';

import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';

import { AwardCreationModule } from './awardCreation.module';
import { CalendarModule } from 'primeng-lts/calendar';
import { ConfirmationService } from 'primeng-lts/api';
import { ButtonModule } from 'primeng-lts/button';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { DialogModule } from 'primeng-lts/dialog';
import { DropdownModule } from 'primeng-lts/dropdown';
import { MenuModule } from 'primeng-lts/menu';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TabViewModule } from 'primeng-lts/tabview';
import { TooltipModule } from 'primeng-lts/tooltip';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { ToggleButtonModule } from 'primeng-lts/togglebutton';
import { ValidationModule } from '../../components/common/validation/validation.module';

@NgModule({
  declarations: [
    awardEditionComponent,
    awardsListComponent,
    AwardDeclaraNoAdjComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    DossierHeaderModule,
    DossierDetailModule,
    DocumentFileModule,
    TableModule,
    TooltipModule,
    ProgressBarModule,
    ToggleButtonModule,
    FormPlycaModule,
    PanelModule,
    TabViewModule,
    MultiSelectModule,
    MenuModule,
    ButtonModule,
    DropdownModule,
    ConfirmDialogModule,
    TranslateModule,
    MainPipes,
    WaitLoadingModule,
    DynamicDialogModule,
    SubHeaderModule,
    AwardCreationModule,
    ScrollPanelModule,
    DialogModule,
    CalendarModule,
    ValidationModule
  ],
  providers: [DialogService, ConfirmationService]
})
export class AwardModule { }
